module.exports = __webpack_public_path__ + "img/month_switcher_arrow-left.0c2ddaff.svg";